/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeEvery, takeLatest } from "redux-saga/effects";
import { Rets, AssetRequests, Logs, User, ContactAsset } from "../api/agent";
import handleFailedAuth from "../helpers/handleExpiredToken";
import { saveFile } from "../helpers";
import showToast from "../helpers/toastNotification";

import {
  SAVE_ASSET,
  FAILURE_SAVE_ASSET,
  SUCCESS_SAVE_ASSET,
  ASSET_LIST_REQUEST,
  ASSET_LIST_SUCCESS,
  ASSET_LIST_FAILURE,
  ASSET_DETAIL_REQUEST,
  ASSET_DETAIL_SUCCESS,
  ASSET_DETAIL_FAILURE,
  DELETE_ASSET,
  DELETE_ASSET_SUCCESS,
  DELETE_ASSET_FAILURE,
  LOOKUP_ASSET,
  LOOKUP_ASSET_SUCCESS,
  LOOKUP_ASSET_FAILURE,
  HAS_ASSET,
  HAS_ASSET_SUCCESS,
  HAS_ASSET_FAILURE,
  SAVE_ASSET_NOT_FOUND_LOG,
  BULK_ADD_ASSET,
  BULK_ADD_ASSET_SUCCESS,
  BULK_ADD_ASSET_FAILURE,
  DOWNLOAD_BULK_ADD_CSV,
  DOWNLOAD_ASSETS_BULK_ADD_CSV,
  BULK_ADD_CLIENT_SUCCESS,
  BULK_ADD_CLIENT,
  BULK_ADD_CLIENT_FAILURE,
  LOOKUP_PARCEL,
  LOOKUP_PARCEL_SUCCESS,
  LOOKUP_PARCEL_FAILURE,
  ADD_ASSET_AND_FINANCIALS,
  ADD_ASSET_AND_FINANCIALS_SUCCESS,
  ADD_ASSET_AND_FINANCIALS_FAILURE,
} from "../actions/asset/assetActionTypes";

import {
  GET_ASSET_BASIC_INFO_SUCCESS,
  GET_ASSET_BASIC_INFO_FAILURE,
  GET_ASSET_BASIC_INFO,
  UPDATE_ASSET_BASIC_INFO,
  UPDATE_ASSET_BASIC_INFO_SUCCESS,
  UPDATE_ASSET_BASIC_INFO_FAILURE,
  GET_ASSET_INVESTMENT_INFO_SUCCESS,
  GET_ASSET_INVESTMENT_INFO_FAILURE,
  GET_ASSET_INVESTMENT_INFO,
  UPDATE_ASSET_INVESTMENT_INFO_SUCCESS,
  UPDATE_ASSET_INVESTMENT_INFO_FAILURE,
  UPDATE_ASSET_INVESTMENT_INFO,
  GET_ACCOUNT_DETAIL,
  GET_ACCOUNT_DETAIL_SUCCESS,
  GET_ACCOUNT_DETAIL_FAILURE,
  GET_ASSET_EXPENSES,
  GET_ASSET_EXPENSES_SUCCESS,
  GET_ASSET_EXPENSES_FAILURE,
  GET_ASSET_INCOMES,
  GET_ASSET_INCOMES_SUCCESS,
  GET_ASSET_INCOMES_FAILURE,
  GET_ASSET_CASHFLOW,
  GET_ASSET_CASHFLOW_SUCCESS,
  GET_ASSET_CASHFLOW_FAILURE,
  GET_ASSET_VALUATION,
  GET_ASSET_VALUATION_SUCCESS,
  GET_ASSET_VALUATION_FAILURE,
  GET_ASSET_MONTHWISE_EXPENSES_SUCCESS,
  GET_ASSET_MONTHWISE_EXPENSES_FAILURE,
  GET_ASSET_MONTHWISE_EXPENSES,
  GET_ASSET_MONTHWISE_INCOMES,
  GET_ASSET_MONTHWISE_INCOMES_FAILURE,
  GET_ASSET_MONTHWISE_INCOMES_SUCCESS,
  GET_NOTIFICATIONS,
  GET_MONTHLY_OVERALL_CASHFLOW_FAILURE,
  GET_MONTHLY_OVERALL_CASHFLOW_SUCCESS,
  GET_MONTHLY_OVERALL_CASHFLOW,
  GET_ASSET_STATS,
  GET_ASSET_STATS_SUCCESS,
  GET_ASSET_STATS_FAILURE,
  GET_TOTAL_MONTHLY_STATS,
  GET_TOTAL_MONTHLY_STATS_FAILURE,
  GET_TOTAL_MONTHLY_STATS_SUCCESS,
  GET_DASHBOARD_STATS,
  GET_DASHBOARD_STATS_FAILURE,
  GET_DASHBOARD_STATS_SUCCESS,
  EXPORT_TO_EXCEL,
  EXPORT_TO_EXCEL_SUCCESS,
  EXPORT_TO_EXCEL_FAILURE,
  GET_MONTHLY_GRAPH_SUCCESS,
  GET_MONTHLY_GRAPH_FAILURE,
  GET_MONTHLY_GRAPH,
  GET_YEARLY_GRAPH_FAILURE,
  GET_YEARLY_GRAPH_SUCCESS,
  GET_YEARLY_GRAPH,
  UPDATE_INCOME_GOAL,
  UPDATE_INCOME_GOAL_SUCCESS,
  UPDATE_INCOME_GOAL_FAILURE,
  GET_ASSET_CHECKLIST,
  GET_ASSET_CHECKLIST_SUCCESS,
  GET_ASSET_CHECKLIST_FAILURE,
  GET_CASHFLOW_GRAPH_FAILURE,
  GET_CASHFLOW_GRAPH_SUCCESS,
  GET_CASHFLOW_GRAPH,
  ADD_ASSET_MEDIAS,
  ADD_ASSET_MEDIAS_SUCCESS,
  ADD_ASSET_MEDIAS_FAILURE,
  GET_ASSET_MEDIAS,
  GET_ASSET_MEDIAS_SUCCESS,
  GET_ASSET_MEDIAS_FAILURE,
  DELETE_ASSET_MEDIA,
  DELETE_ASSET_MEDIA_SUCCESS,
  DELETE_ASSET_MEDIA_FAILURE,
  GET_OVERALL_CASHFLOW,
  GET_OVERALL_CASHFLOW_SUCCESS,
  GET_OVERALL_CASHFLOW_FAILURE,
  GET_CONTACT_ASSETS,
  GET_CONTACT_ASSETS_SUCCESS,
  ADD_CONTACT_ASSETS,
  ADD_ASSETS_DOCUMENT,
  SAVE_CONTACT_ASSETS_TRANSACTIONS,
  SAVE_CONTACT_ASSETS_TRANSACTIONS_SUCCESS,
  SAVE_CONTACT_ASSETS_TRANSACTIONS_FAILURE,
  CLEAR_PARTNER_ASSETS,
  BULK_ADD_CLIENT_ASSETS,
  MANUAL_BULK_ADD_CLIENT_ASSETS,
} from "../actions/actionTypes";

function* saveAsset(action) {
  try {
    const retsResp = yield call(AssetRequests.saveAsset, action.payload);
    yield put({ type: SUCCESS_SAVE_ASSET, payload: retsResp });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: FAILURE_SAVE_ASSET, err });
  }
}

export function* watchSaveAsset() {
  yield takeEvery(SAVE_ASSET, saveAsset);
}

//asset listing
export function* asset_list() {
  try {
    const payload = yield call(AssetRequests.assetListing);
    yield put({ type: ASSET_LIST_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: ASSET_LIST_FAILURE, err });
  }
}

export function* watchAssetList() {
  yield takeEvery(ASSET_LIST_REQUEST, asset_list);
}

//fetch particular asset's detail
export function* asset_detail(action) {
  try {
    const payload = yield call(AssetRequests.assetDetailing, action.payload);
    yield put({ type: ASSET_DETAIL_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: ASSET_DETAIL_FAILURE, err });
  }
}

export function* watchAssetDetail() {
  yield takeEvery(ASSET_DETAIL_REQUEST, asset_detail);
}

// ASSET BASIC INFO SAGAS
export function* getAssetBasicInfo(action) {
  try {
    const payload = yield call(AssetRequests.getBasicInfo, action.payload);
    yield put({ type: GET_ASSET_BASIC_INFO_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: GET_ASSET_BASIC_INFO_FAILURE, err });
  }
}

export function* watchGetAssetBasicInfo() {
  yield takeEvery(GET_ASSET_BASIC_INFO, getAssetBasicInfo);
}

export function* updateAssetBasicInfo(action) {
  try {
    const payload = yield call(AssetRequests.updateBasicInfo, action.payload);
    yield put({ type: UPDATE_ASSET_BASIC_INFO_SUCCESS, payload });
    showToast("s", "Updated Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Save Changes");
    const err = error.response.body;
    yield put({ type: UPDATE_ASSET_BASIC_INFO_FAILURE, err });
  }
}

export function* watchUpdateAssetBasicInfo() {
  yield takeEvery(UPDATE_ASSET_BASIC_INFO, updateAssetBasicInfo);
}

// ASSET INVESTMENT SAGAS
export function* getAssetInvestmentInfo(action) {
  try {
    const payload = yield call(AssetRequests.getInvestmentInfo, action.payload);
    yield put({ type: GET_ASSET_INVESTMENT_INFO_SUCCESS, payload });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: GET_ASSET_INVESTMENT_INFO_FAILURE, err });
  }
}

export function* watchGetAssetInvestmentInfo() {
  yield takeEvery(GET_ASSET_INVESTMENT_INFO, getAssetInvestmentInfo);
}

export function* updateAssetInvestmentInfo(action) {
  try {
    const payload = yield call(
      AssetRequests.updateInvestmentInfo,
      action.payload
    );
    yield put({ type: UPDATE_ASSET_INVESTMENT_INFO_SUCCESS, payload });
    showToast("s", "Updated Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    showToast("e", "Unable To Save Changes");
    const err = error.response.body;
    yield put({ type: UPDATE_ASSET_INVESTMENT_INFO_FAILURE, err });
  }
}

export function* watchUpdateAssetInvestmentInfo() {
  yield takeEvery(UPDATE_ASSET_INVESTMENT_INFO, updateAssetInvestmentInfo);
}

//DELETE ASSET

export function* deleteAsset(action) {
  try {
    const payload = yield call(AssetRequests.deleteAsset, action.payload);
    yield put({ type: DELETE_ASSET_SUCCESS, payload });
    //  Checking for new notification when new financials are added
    yield put({ type: GET_NOTIFICATIONS });

    showToast("s", "Asset Deleted Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: DELETE_ASSET_FAILURE, err });
  }
}

export function* watchDeleteAsset() {
  yield takeEvery(DELETE_ASSET, deleteAsset);
}

function* lookupAsset(action) {
  try {
    const retsResp = yield call(Rets.lookupAsset, action.payload);
    yield put({ type: LOOKUP_ASSET_SUCCESS, payload: retsResp });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: LOOKUP_ASSET_FAILURE, err });
  }
}

export function* watchLookupAsset() {
  yield takeEvery(LOOKUP_ASSET, lookupAsset);
}

function* bulkAddAsset(action) {
  try {
    const retsResp = yield call(AssetRequests.bulkAddAsset, action.payload);
    yield put({ type: BULK_ADD_ASSET_SUCCESS, payload: retsResp });
    showToast("s", "Assets successfully imported");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    showToast("e", "Unable to import assets");
    yield put({ type: BULK_ADD_ASSET_FAILURE, err });
  }
}

export function* watchBulkAddAsset() {
  yield takeEvery(BULK_ADD_ASSET, bulkAddAsset);
}

function* bulkClientAdd(action) {
  try {
    const retsResp = yield call(AssetRequests.bulkAddClient, action.payload);
    yield put({ type: BULK_ADD_CLIENT_SUCCESS, payload: retsResp });
    showToast("s", "Assets successfully imported");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    showToast("e", "Unable to import assets");
    yield put({ type: BULK_ADD_CLIENT_FAILURE, err });
  }
}

export function* watchBulkAddClient() {
  yield takeEvery(BULK_ADD_CLIENT, bulkClientAdd);
}

function* downloadBulkAddCSV(action) {
  try {
    const fileData = yield call(
      AssetRequests.downloadBulkAddCSV,
      action.payload
    );
    saveFile(fileData, "bulk_add_assets.csv");
  } catch (error) {}
}

export function* watchDownloadBulkAddCSV() {
  yield takeLatest(DOWNLOAD_BULK_ADD_CSV, downloadBulkAddCSV);
}

function* downloadAssetsBulkAddCSV(action) {
  try {
    const fileData = yield call(
      AssetRequests.downloadAssetsBulkAddCSV,
      action.payload
    );
    saveFile(fileData, "bulk_add_assets.csv");
  } catch (error) {}
}

export function* watchDownloadAssetsBulkAddCSV() {
  yield takeLatest(DOWNLOAD_ASSETS_BULK_ADD_CSV, downloadAssetsBulkAddCSV);
}

function* getAccountDetail(action) {
  try {
    const payload = yield call(AssetRequests.getAccountDetail, action.payload);
    yield put({ type: GET_ACCOUNT_DETAIL_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ACCOUNT_DETAIL_FAILURE, errResp });
  }
}

export function* watchGetAccountDetail() {
  yield takeLatest(GET_ACCOUNT_DETAIL, getAccountDetail);
}

function* getAssetExpenses(action) {
  try {
    const payload = yield call(AssetRequests.getAssetExpenses, action.payload);
    yield put({ type: GET_ASSET_EXPENSES_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_EXPENSES_FAILURE, errResp });
  }
}

export function* watchGetAssetExpenses() {
  yield takeLatest(GET_ASSET_EXPENSES, getAssetExpenses);
}

function* getAssetIncomes(action) {
  try {
    const payload = yield call(AssetRequests.getAssetIncomes, action.payload);
    yield put({ type: GET_ASSET_INCOMES_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_INCOMES_FAILURE, errResp });
  }
}

export function* watchGetAssetIncomes() {
  yield takeLatest(GET_ASSET_INCOMES, getAssetIncomes);
}

function* getAssetCashflow(action) {
  try {
    const payload = yield call(AssetRequests.getAssetCashflow, action.payload);
    yield put({ type: GET_ASSET_CASHFLOW_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_CASHFLOW_FAILURE, errResp });
  }
}

export function* watchGetAssetCashflow() {
  yield takeLatest(GET_ASSET_CASHFLOW, getAssetCashflow);
}

function* getMonthlyOverallCashflow(action) {
  try {
    const payload = yield call(
      AssetRequests.getMonthlyOverallCashflow,
      action.payload
    );
    yield put({ type: GET_MONTHLY_OVERALL_CASHFLOW_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_MONTHLY_OVERALL_CASHFLOW_FAILURE, errResp });
  }
}

export function* watchGetMonthlyOverallCashflow() {
  yield takeLatest(GET_MONTHLY_OVERALL_CASHFLOW, getMonthlyOverallCashflow);
}

function* getAssetValuation(action) {
  try {
    const payload = yield call(AssetRequests.getAssetValuation, action.payload);
    yield put({ type: GET_ASSET_VALUATION_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_VALUATION_FAILURE, errResp });
  }
}

export function* watchGetAssetValuation() {
  yield takeLatest(GET_ASSET_VALUATION, getAssetValuation);
}

// GET_MONTHWISE_EXPENSE_SAGAS
function* getMonthwiseExpenses(action) {
  try {
    const payload = yield call(
      AssetRequests.getAssetMonthwiseExpenses,
      action.payload
    );
    yield put({ type: GET_ASSET_MONTHWISE_EXPENSES_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_MONTHWISE_EXPENSES_FAILURE, errResp });
  }
}

export function* watchGetMonthwiseExpenses() {
  yield takeLatest(GET_ASSET_MONTHWISE_EXPENSES, getMonthwiseExpenses);
}

// GET_MONTHWISE_INCOME_SAGAS
function* getMonthwiseIncomes(action) {
  try {
    const payload = yield call(
      AssetRequests.getAssetMonthwiseIncomes,
      action.payload
    );
    yield put({ type: GET_ASSET_MONTHWISE_INCOMES_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_MONTHWISE_INCOMES_FAILURE, errResp });
  }
}

export function* watchGetMonthwiseIncomes() {
  yield takeLatest(GET_ASSET_MONTHWISE_INCOMES, getMonthwiseIncomes);
}

// CHECK_ASSET_SAGA
function* hasAsset(action) {
  try {
    const payload = yield call(AssetRequests.hasAsset, action.payload);
    yield put({ type: HAS_ASSET_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: HAS_ASSET_FAILURE, errResp });
  }
}

export function* watchHasAsset() {
  yield takeLatest(HAS_ASSET, hasAsset);
}

function* getTotalMonthlyStats(action) {
  try {
    const payload = yield call(AssetRequests.getTotalMonthlyStats);
    yield put({ type: GET_TOTAL_MONTHLY_STATS_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_TOTAL_MONTHLY_STATS_FAILURE, errResp });
  }
}

function* getDashboardStats(action) {
  try {
    const payload = yield call(AssetRequests.getDashboardStats);
    yield put({ type: GET_DASHBOARD_STATS_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_DASHBOARD_STATS_FAILURE, errResp });
  }
}

export function* watchGetTotalMonthlyStats() {
  yield takeLatest(GET_TOTAL_MONTHLY_STATS, getTotalMonthlyStats);
}

export function* watchGetDashboardStats() {
  yield takeLatest(GET_DASHBOARD_STATS, getDashboardStats);
}

function* getAssetStats(action) {
  try {
    const payload = yield call(AssetRequests.getAssetStats, action.payload);
    yield put({ type: GET_ASSET_STATS_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_STATS_FAILURE, errResp });
  }
}

export function* watchGetAssetStats() {
  yield takeLatest(GET_ASSET_STATS, getAssetStats);
}

function* saveAssetNotFoundLog(action) {
  try {
    yield call(Logs.saveAssetNotFoundLog, action.payload);
    // yield put({ type: GET_ASSET_STATS_SUCCESS, payload });
  } catch (err) {
    // const errResp = err.response.body;
    // yield put({ type: GET_ASSET_STATS_FAILURE, errResp });
  }
}

export function* watchSaveAssetNotFoundLog() {
  yield takeLatest(SAVE_ASSET_NOT_FOUND_LOG, saveAssetNotFoundLog);
}

function* exportToExcel(action) {
  try {
    const fileData = yield call(AssetRequests.exportToExcel, action.payload);
    const { assetName, exportType } = action.payload;
    let filename = assetName ? assetName : "Download";
    filename += "_" + (exportType ? exportType + ".xlsx" : ".xlsx");

    saveFile(fileData, filename);
    yield put({ type: EXPORT_TO_EXCEL_SUCCESS });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: EXPORT_TO_EXCEL_FAILURE, errResp });
  }
}

export function* watchExportToExcel() {
  yield takeLatest(EXPORT_TO_EXCEL, exportToExcel);
}

function* getYearlyGraph(action) {
  try {
    const payload = yield call(AssetRequests.getYearlyGraph, action.payload);
    yield put({ type: GET_YEARLY_GRAPH_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_YEARLY_GRAPH_FAILURE, errResp });
  }
}

export function* watchGetYearlyGraph() {
  yield takeLatest(GET_YEARLY_GRAPH, getYearlyGraph);
}

function* getMonthlyGraph(action) {
  try {
    const payload = yield call(AssetRequests.getMonthlyGraph, action.payload);
    yield put({ type: GET_MONTHLY_GRAPH_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_MONTHLY_GRAPH_FAILURE, errResp });
  }
}

export function* watchGetMonthlyGraph() {
  yield takeLatest(GET_MONTHLY_GRAPH, getMonthlyGraph);
}

function* getCashFlowGraph(action) {
  try {
    const payload = yield call(AssetRequests.getCashFlowGraph, action.payload);
    yield put({ type: GET_CASHFLOW_GRAPH_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_CASHFLOW_GRAPH_FAILURE, errResp });
  }
}

export function* watchGetCashFlowGraph() {
  yield takeLatest(GET_CASHFLOW_GRAPH, getCashFlowGraph);
}

function* updateIncomeGoal(action) {
  try {
    const payload = yield call(AssetRequests.updateIncomeGoal, action.payload);
    yield put({ type: UPDATE_INCOME_GOAL_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: UPDATE_INCOME_GOAL_FAILURE, errResp });
  }
}

export function* watchUpdateIncomeGoal() {
  yield takeLatest(UPDATE_INCOME_GOAL, updateIncomeGoal);
}

function* getAssetChecklist(action) {
  try {
    const payload = yield call(AssetRequests.getChecklist, action.payload);
    yield put({ type: GET_ASSET_CHECKLIST_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_ASSET_CHECKLIST_FAILURE, errResp });
  }
}

export function* watchGetAssetChecklist() {
  yield takeLatest(GET_ASSET_CHECKLIST, getAssetChecklist);
}

function* addAssetMedias(action) {
  try {
    const payload = yield call(AssetRequests.addMedias, action.payload);
    yield put({ type: ADD_ASSET_MEDIAS_SUCCESS, payload });
  } catch (error) {
    const errResp = { message: "Error while uploading media" };
    yield put({ type: ADD_ASSET_MEDIAS_FAILURE, errResp });
  }
}

export function* watchAddAssetMedias() {
  yield takeEvery(ADD_ASSET_MEDIAS, addAssetMedias);
}

function* getAssetMedias(action) {
  try {
    const payload = yield call(AssetRequests.getMedias, action.payload);
    yield put({ type: GET_ASSET_MEDIAS_SUCCESS, payload });
  } catch (error) {
    const errResp = { message: "Error while fetching asset media" };
    yield put({ type: GET_ASSET_MEDIAS_FAILURE, errResp });
  }
}

export function* watchGetAssetMedias() {
  yield takeEvery(GET_ASSET_MEDIAS, getAssetMedias);
}

function* getOverallCashflow(action) {
  try {
    const payload = yield call(User.getOverallCashflow, action.payload);
    yield put({ type: GET_OVERALL_CASHFLOW_SUCCESS, payload });
  } catch (error) {
    const errResp = { message: "Error while fetching monthly snapshot" };
    yield put({ type: GET_OVERALL_CASHFLOW_FAILURE, errResp });
  }
}

export function* watchGetMonthlySnapshot() {
  yield takeEvery(GET_OVERALL_CASHFLOW, getOverallCashflow);
}

function* deleteAssetMedia(action) {
  try {
    const payload = yield call(AssetRequests.deleteMedia, action.payload);
    yield put({ type: DELETE_ASSET_MEDIA_SUCCESS, payload });
  } catch (error) {
    const errResp = { message: "Error while fetching asset media" };
    yield put({ type: DELETE_ASSET_MEDIA_FAILURE, errResp });
  }
}

export function* watchDeleteAssetMedia() {
  yield takeEvery(DELETE_ASSET_MEDIA, deleteAssetMedia);
}

function* getContactAssets(action) {
  try {
    const { slug, page } = action.payload;
    yield put({ type: CLEAR_PARTNER_ASSETS });
    const payload = yield call(ContactAsset.getAssets, slug, page);
    yield put({ type: GET_CONTACT_ASSETS_SUCCESS, payload });
  } catch (e) {
    console.log(e);
  }
}

export function* watchGetContactAssets() {
  yield takeEvery(GET_CONTACT_ASSETS, getContactAssets);
}

function* addContactAssets(action) {
  try {
    const { data, slug } = action.payload;
    yield call(ContactAsset.addAssetContact, data, slug);
    yield put({ type: GET_CONTACT_ASSETS, payload: { slug, page: 0 } });

    showToast("s", "Asset Added Successfully");
  } catch (e) {
    showToast("e", e.message || "Unable To Add Asset");
  }
}

export function* watchAddContactAssets() {
  yield takeEvery(ADD_CONTACT_ASSETS, addContactAssets);
}

function* addAssetsDocument(action) {
  try {
    const { params } = action.payload;
    yield call(ContactAsset.addAssetDocument, action.payload, params);
    showToast("s", "Document successfully added");
  } catch (e) {
    showToast("e", "Unable to add document");
  }
}

export function* watchAddDocument() {
  yield takeEvery(ADD_ASSETS_DOCUMENT, addAssetsDocument);
}

function* saveTransaction(action) {
  try {
    const { assetsSlug, clientSlug, data } = action.payload;
    const payload = yield call(
      ContactAsset.savePartnerTransactions,
      { data: data },
      clientSlug,
      assetsSlug
    );
    yield put({ type: SAVE_CONTACT_ASSETS_TRANSACTIONS_SUCCESS, payload });
    showToast("s", "Transaction successfully added");
  } catch (error) {
    showToast("e", "Unable To Save Transaction");
    const errResp = error.response.body;
    yield put({ type: SAVE_CONTACT_ASSETS_TRANSACTIONS_FAILURE, errResp });
  }
}

export function* watchSavePartnerTransactions() {
  yield takeEvery(SAVE_CONTACT_ASSETS_TRANSACTIONS, saveTransaction);
}

function* bulkAddClientAssets(action) {
  try {
    const { clientSlug, page } = action.payload;
    yield call(ContactAsset.bulkAddClientAssets, action.payload);
    yield put({
      type: GET_CONTACT_ASSETS,
      payload: {
        slug: clientSlug,
        page,
      },
    });
    showToast("s", "Assets successfully imported");
  } catch (e) {
    showToast("e", "Unable to add assets");
  }
}

export function* watchBulkAddClientAssets() {
  yield takeEvery(BULK_ADD_CLIENT_ASSETS, bulkAddClientAssets);
}

function* manualBulkAddAssets(action) {
  try {
    const { data } = action.payload;
    yield call(ContactAsset.manualBulkAddAssets, data);
    showToast("s", "Assets successfully imported");
  } catch (e) {
    showToast("e", "Unable to add assets");
  }
}

export function* watchManualBulkAddClientAssets() {
  yield takeEvery(MANUAL_BULK_ADD_CLIENT_ASSETS, manualBulkAddAssets);
}

function* lookupParcel(action) {
  try {
    const retsResp = yield call(Rets.lookupParcel, action.payload);
    yield put({ type: LOOKUP_PARCEL_SUCCESS, payload: retsResp });
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: LOOKUP_PARCEL_FAILURE, err });
  }
}

export function* watchLookupParcel() {
  yield takeEvery(LOOKUP_PARCEL, lookupParcel);
}

function* addAssetAndFinancials(action) {
  try {
    const retsResp = yield call(
      AssetRequests.addAssetAndFinancials,
      action.payload
    );
    yield put({ type: ADD_ASSET_AND_FINANCIALS_SUCCESS, payload: retsResp });
    showToast("s", "Asset Added Successfully");
  } catch (error) {
    if (error.response.status === 401 || error.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const err = error.response.body;
    yield put({ type: ADD_ASSET_AND_FINANCIALS_FAILURE, err });
  }
}

export function* watchAddAssetAndFinancials() {
  yield takeEvery(ADD_ASSET_AND_FINANCIALS, addAssetAndFinancials);
}
